const GoOpen = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 266.33 196.67">
    <path d="m224.78 60.19 41.55 55.23-13.26 49.68-37.49 24.03-45.57-7.73-19.74-30.61 3.22-8.92 21.05 32.63 39.42 6.7 32.92-21.08 10.82-43.13-35.96-48.8-59.99 7.55-10.36.12 1.9-6.64 71.49-9.03z" />
    <path
      d="m221.75 68.19 36 48.8-10.82 43.13-32.96 21.08-39.42-6.7-21.05-32.64 23.91-66.28-15.65.16zm-5 68.55 4.88-20-21.16-12.89-21.58 8-2.8 20 14.65 9.38 13.62 5.12z"
      fill="#ffc300"
    />
    <path d="m221.59 116.78-4.88 20-12.4 9.61-13.62-5.12-14.65-9.38 2.8-20 21.58-8zm-11.58 15.6 2.92-12-13.31-8.13-13.94 5.14-1.51 10.71 10.22 6.57 8.58 3.14z" />
    <path
      fill="#fd6412"
      d="m157.32 82.61-7.95.27-46.27 1.62-13.46 36.18 32.53-3.24-10.09 30.24-42.98-5.59-21.18-35.12 9.63-39.61 37.42-22.63 21.49 17.93 45.93-12.54-26.45-40.33-69.19-.98-54.97 38.24-3.52 88.75 30.85 52.02 90.61-9.97 14.21-36.89 3.36-8.7 19.26-49.98-9.23.33z"
    />
    <path d="m161.76 75.74-10.37.11-54.22.57-20.07 53.92 33-3.35-3.81 11.51-32.12-4.16-17.32-28.76 8-32.91 29.32-17.7 20.3 16.86 61.22-16.7-34.75-52.92L64.87 0 3.17 42.78l-3.2 95.09 34 58.8 103.76-11.09 12.54-34.8 3.22-8.92 23.92-66.28zm-14.47 56.51-3.35 8.71-14.22 36.88-90.61 10-30.85-52 3.52-88.75 55-38.24 69.18 1 26.45 40.33-45.95 12.47-21.49-17.92-37.42 22.63-9.63 39.61 21.19 35.12 43 5.59 10.06-30.24-32.54 3.24 13.46-36.18 46.27-1.61 8-.27 9.24-.33z" />
  </svg>
);

export default GoOpen;
